import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import T from 'prop-types';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { createPropTypes, margin, textAlign, textColor, variant, compose } from '../../styles/system';
import { createShouldForwardProp } from '../../helpers/createShouldForwardProp';
import * as typography from '../../styles/typography';
import { jsx as _jsx } from "react/jsx-runtime";
const variantToElement = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  subtitle1: 'p',
  subtitle2: 'p',
  body1: 'p',
  body2: 'p',
  caption: 'span',
  overline: 'span'
};
const variantMargin = {
  h1: 6,
  h2: 6,
  h3: 6,
  h4: 4,
  h5: 4,
  subtitle1: 4,
  subtitle2: 4,
  body1: 4,
  body2: 4
};
const styleVariant = variant({
  h1: typography.h1,
  h2: typography.h2,
  h3: typography.h3,
  h4: typography.h4,
  h5: typography.h5,
  subtitle1: typography.subtitle1,
  subtitle2: typography.subtitle2,
  body1: typography.body1,
  body2: typography.body2,
  caption: typography.caption,
  overline: typography.overline
});
const styleProps = compose(styleVariant, margin, textAlign, textColor);
const shouldForwardProp = createShouldForwardProp(styleProps.propNames);
const StyledText = /*#__PURE__*/styled.p.withConfig({
  shouldForwardProp
})(styleProps);
const Text = /*#__PURE__*/forwardRef(function Text(_ref, forwardedRef) {
  let {
    variant: textVariant = 'body1',
    as,
    children,
    mb
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["variant", "as", "children", "mb"]);

  const Component = as || variantToElement[textVariant];
  const marginBottom = mb !== null && mb !== void 0 ? mb : variantMargin[textVariant];
  return /*#__PURE__*/_jsx(StyledText, Object.assign({
    ref: forwardedRef,
    as: Component,
    variant: textVariant,
    mb: marginBottom
  }, restProps, {
    children: children
  }));
});
Text.propTypes = Object.assign({}, createPropTypes(styleProps.propNames), {
  as: T.oneOfType([T.string, T.elementType]),
  children: T.node,
  variant: T.oneOf(Object.keys(variantToElement))
});
export { Text };